import { render, staticRenderFns } from "./bySchoolTreesTable.vue?vue&type=template&id=cc7621e4"
import script from "./bySchoolTreesTable.vue?vue&type=script&lang=js"
export * from "./bySchoolTreesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports